function accordionDropdown() {
  class AccordionDropdown extends HTMLElement {
    constructor() {
      super();
  
      this.querySelectorAll('.accordion__button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      let content = event.target.nextElementSibling;
  
      event.target.classList.contains('has-active') ? event.target.classList.remove('has-active') : event.target.classList.add('has-active');
      content.style.maxHeight === `${content.scrollHeight}px` ? content.style.maxHeight = '0px' : content.style.maxHeight = `${content.scrollHeight}px`;
    }
  }
  
  customElements.define('accordion-container', AccordionDropdown);

  document.addEventListener('shopify:section:load', () => {
    const buttons = document.querySelectorAll('.accordion__button');
    console.log('editor load');
    if(!buttons) return;
  
    buttons.forEach(
      (button) => {
        let content = button.nextElementSibling;
        if(button.classList.contains('has-active')) {
      
          activeContent.style.maxHeight = `${activeContent.scrollHeight}px`
        };
  
        console.log(button);
        console.log(content);
        console.log(button.classList.contains('has-active'));
      }
    )
  });
}

accordionDropdown();